namespace RecordShield.Models {
    export enum EViews {
        Zero = 0,
        One = 1,
        Two = 2,
        Three = 3,
        Four = 4,
        Five = 5,
        Six = 6,
        Seven = 7,
        Eight = 8,
        Nine = 9,
        Ten = 10,
        Eleven = 11,
        Twelve = 12,
        Thirteen = 13,
        Fourteen = 14,
        Fifteen = 15,
        Sixteen = 16,
        Seventeen = 17,
        Eighteen = 18,
        Nineteen = 19,
        Twenty = 20,
        TwentyOne = 21,
        TwentyTwo = 22,
        TwentyThree = 23,
        TwentyFour = 24,
        TwentyFive = 25,
        Thirty = 26,
        ThirtyFive = 27,
        Forty = 28,
        FortyFive = 29,
        Fifty = 30,
        FiftyFive = 31,
        Sixty = 32,
        SixtyFive = 33,
        Seventy = 34,
        SeventyFive = 35,
        Eighty = 36,
        EightyFive = 37,
        Ninty = 38,
        NintyFive = 39,
        Hundred = 40,
        OneFifty = 41,
        TwoHundred = 42,
        TwoFifty = 43,
        ThreeHundred = 44,
        FiveHundred = 45,
        Thousand = 46,
        TwoThousand = 47,
        FiveThousand = 48,
        TenThousand = 49,
        Unlimited = 50
    }
    Serenity.Decorators.registerEnum(EViews, 'RecordShield.Models.EViews');
}
